import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MenuCategoriesDataInterface } from 'src/app/interfaces/category.interface';
import { Common } from 'src/app/interfaces/common.interface';
import { HeaderMenuData } from 'src/app/interfaces/header.interface';
import { HeaderService } from 'src/app/service/header.service';

@Component({
  standalone: true,
  selector: 'app-menu-dab',
  templateUrl: './menu-dab.component.html',
  styleUrls: ['./menu-dab.component.css'],
  imports: [CommonModule, RouterLink]
})
export class MenuDabComponent {
  isMenuOpen: boolean = false;
  menuData: any[] = [];

  constructor(
    private router: Router,
    private menuHttp: HeaderService
  ) { }

  ngOnInit(): void {
    this.getMenuData();
  }

  getMenuData(): void {
    this.menuHttp.headerMenuList().subscribe(
      {
        next: (response: Common<HeaderMenuData>) => {
          this.menuData = response[0]?.data;
        }
      })
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  categoriesRedirection(event: MenuCategoriesDataInterface): void {
    if (event && event.menu_link) {
      localStorage.setItem('selectedcategorykey', String(event.menu_key));
      this.router.navigate([event.menu_link]);
      this.isMenuOpen = false;
    } else {
      console.error('Invalid menu_link:', event);
    }
  }
}